// Drawing a scene without the show going there: ?scene=N draws scene N instead of following the live show
// (thumbnails, a gallery of every screen). Screens only draw what the server sends, so nothing starts.
// Add &sample and a game scene draws a made-up mid-game moment instead of its waiting state: the requests a game
// makes for its state are answered here, with the event's real players.
const params = new URLSearchParams(window.location.search);

export const drawnScene = () => {
    const v = params.get('scene');
    return v == null || v === '' || Number.isNaN(Number(v)) ? null : Number(v);
};

const json = (body) => new Response(JSON.stringify(body), {status: 200, headers: {'Content-Type': 'application/json'}});

const players = async (realFetch) => {
    const users = await (await realFetch('/users/')).json();
    return users.filter(u => u.character && u.character.image_url)
        .map(u => ({token: u.token, name: u.name, nickname: u.character.nickname, image_url: u.character.image_url}));
};

const componentAt = async (realFetch, index) => {
    const doc = await (await realFetch('/show')).json();
    const scene = doc.blocks.flatMap(b => b.scenes)[index];
    return scene && scene.el.$el;
};

const SAMPLES = {
    '/allegedly-true/state': async (cast) => {
        const p = cast[0];
        return {
            facts: [
                {id: 1, display_order: 0, display_as: 'narration', transition_text: 'Welcome to Allegedly True.', status: 'ready', included: true},
                {id: 2, display_order: 1, display_as: 'true', display_text: `${p.name} once won a hot dog eating contest.`,
                    true_fact: `${p.name} once won a hot dog eating contest.`, transition_text: `A claim about ${p.name}. True, or false?`,
                    image_path: p.image_url, status: 'ready', included: true},
                {id: 3, display_order: 2, display_as: 'narration', transition_text: 'That is all.', status: 'ready', included: true},
            ],
            currentFactId: 2, currentPhase: 'voting', votingEndsAt: Date.now() + 12000,
            currentTally: {count: Math.ceil(cast.length * 0.6), total: cast.length, true: null, false: null},
            pendingVoters: [], yourVote: null, yourScore: null, auto: true,
        };
    },
    '/bargain/state': async (cast) => {
        const p = cast[1] || cast[0];
        return {
            phase: 'presence', currentLine: `Is there a ${p.nickname} in the house? Step forward, ${p.name}. Make yourself known.`,
            expect: 'any', selectee: p, victim: null, amount: null, board: null, transfer: null,
            lineId: 'sample', lineDone: true, verdictGo: false,
        };
    },
    '/leaderboard/live': async (cast) => {
        const p = cast[2] || cast[0];
        return {leaderboard: {scene: drawnScene(), type: 'end', index: 0, showAll: false, sentences: [
            {speech: `Your champion: ${p.name}, ${p.nickname}!`, role: 'podium1', reveal: true,
                scores: [{character: p, score: 2400, rank: 1}]},
        ]}};
    },
    '/dialog': async (cast) => {
        const p = cast[3] || cast[0];
        return {dialog: {scene: drawnScene(), index: 1, characters: cast, cast,
            sequence: ['Oh. The membership has assembled.', `${p.name}, ${p.nickname}. I have my eye on you.`]}};
    },
    // The line on screen for the scene drawn: its sample's own, already said.
    '/speech': async (cast, realFetch) => {
        const scene = drawnScene(), component = await componentAt(realFetch, scene);
        if (component === 'AiDialog') {
            const {dialog} = await SAMPLES['/dialog'](cast);
            return {speech: {id: `dialog:line:${scene}:1`, text: dialog.sequence[1], startedAt: 0, endedAt: 1}};
        }
        if (component === 'Leaderboard') {
            const {leaderboard} = await SAMPLES['/leaderboard/live'](cast);
            return {speech: {id: `leaderboard:line:${scene}:0`, text: leaderboard.sentences[0].speech, startedAt: 0, endedAt: 1}};
        }
        return {speech: null};
    },
};

export const installSamples = () => {
    if (!params.has('sample')) return;
    const realFetch = window.fetch;
    let cast = null;
    window.fetch = async (input, init) => {
        const url = typeof input === 'string' ? input : input && input.url;
        const sample = url && SAMPLES[new URL(url, window.location.origin).pathname];
        if (!sample) return realFetch(input, init);
        cast = cast || await players(realFetch);
        return json(await sample(cast, realFetch));
    };
};
